import { IssuesAmountProps } from './AllIssues.consts';
import { useTranslation } from 'react-i18next';

export const IssuesAmount: React.FC<IssuesAmountProps> = ({ issuesAmount }: IssuesAmountProps) => {
  const { t } = useTranslation();
  return (
    <>
      {issuesAmount ? (
        <>
          ({issuesAmount})
          <span className="u1st-sr-only">
            {t('free_tools.accessibility_checker.all_issues.issues')}
          </span>
        </>
      ) : (
        <span className="u1st-sr-only">
          - {t('free_tools.accessibility_checker.all_issues.no_issues')}
        </span>
      )}
    </>
  );
};
